import { createStore } from 'vuex';
import persistedStateVuex from 'persisted-state-vuex';
export default createStore({
  state: {
    userLogged: null,
    userAvatar: null
  },
  getters: {},
  mutations: {
    getUserLogged(state, value) {
      console.log('render user', value);
      state.userLogged = value.name;
      state.userAvatar = value.userProfile;
    }
  },
  actions: {},
  modules: {},
  plugins: [persistedStateVuex.init]
});
